export const CustomerType = {
    "Amazon": "#ff9900",
    "Bison Office": "#bf8040",
    "Cartesian": "#4d6600",
    "Cymax": "#0000b3",
    "OJ Commerce": "#0047AB",
    "Overstock": "#cc0000",
    "UnbeatableSale": "#ff884d",
    "V Furniture Direct": "#999966",
    "Virventures": "#339966",
    "Wayfair": "#6600cc",
    "DirectSales": "Direct Sales"
}